import React, { memo } from "react";
import DFIAppMain from "./main/index";
const App = memo(() => {
    return React.createElement(DFIAppMain, null);
});
export default App;
